// extracted by mini-css-extract-plugin
module.exports = {"secondFold":"secondFold_secondFold__XwiG4","mainDiv":"secondFold_mainDiv__4__4M","link":"secondFold_link__AYhjt","heading":"secondFold_heading__ICa8W"};